export const parseTitle = (input) => {
    const regex = /@([^@]+)@/g;

    let output = input?.replace(regex, '<span class="highlight">$1</span>');

    return <span dangerouslySetInnerHTML={{ __html: output }} />;
};